module.exports = __webpack_public_path__ + "img/2-fontane-pirotecniche.d1acde7a.jpg";